import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import PropTypes from 'prop-types';

const ScheduledMeetings = ({
  meetingList = null,
  getMeetingList = null,
  match,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const Headers = [
    'Meeting Agenda',
    'Scheduled Date',
    'BA Name',
    'Actions',
  ];

  useEffect(() => {
    if (getMeetingList !== null)
      (async () => {
        setIsLoading(true);
        await getMeetingList(match.params.id);
        setIsLoading(false);
      })();
  }, [getMeetingList]);

  useEffect(() => {
    const tableData = [
      'id',
      'subject',
      'scheduled_date',
      'name',
    ];
    const data =
      meetingList?.length &&
      meetingList.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Action:
              /* element.mom_send_status === 0 &&
              // (element.status === 'Cancelled' || element.status === 'Completed')
              element.status === 'Cancelled'
                ? [
                    {
                      name: 'View Details',
                      link: `${baseUrl}/brand-activation/scheduled-meeting-details`,
                    },
                  ]
                : [
                    {
                      name: 'View Details',
                      link: `${baseUrl}/brand-activation/scheduled-meeting-details`,
                    },
                    {
                      name: `${
                        element.mom_send_status === 0
                          ? localization.createMom
                          : localization.viewMom
                      }`,
                      link: `${
                        element.mom_send_status === 0
                          ? `${baseUrl}/brand-activation/create-minutes-of-meeting`
                          : `${baseUrl}/brand-activation/view-minutes-of-meeting`
                      }`,
                    },
                  ], */
              [
                {
                  name: 'View Details',
                  link: `${baseUrl}/brand-activation/scheduled-meeting-details`,
                },
              ]
          }
        )
      );
    meetingList?.length && data && setListData(data);
  }, [meetingList]);

  const headerBtns = () => {
    return (
      <Fragment>
        <Link
          to={`${baseUrl}/brand-activation/schedule-a-meeting/${match?.params?.id}`}
          className="btn btn-primary d-md-inline-block"
        >
          {localization.scheduleMeeting}
          <img src={Images?.ArrowRight} alt="" />
        </Link>
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.meetingHistory}
      Buttons={headerBtns}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/sites-listing`}
    >
      <TableSection
        data={listData}
        headers={Headers}
        detailList={meetingList}
        isId={false}
      />
    </Layout>
  );
};

ScheduledMeetings.propTypes = {
  meetingList: PropTypes.any,
  getMeetingList: PropTypes.func,
  match: PropTypes.any,
};

export default ScheduledMeetings;
